import ta from 'time-ago';
const CreatedAt = ({ createdAt }) => <span style={{ fontSize: 10 }}>{ta.ago(createdAt)}</span>;
export default CreatedAt;
